import { render } from "./ProductSelectionProductsSelection.vue?vue&type=template&id=2da4323b&scoped=true&ts=true"
import script from "./ProductSelectionProductsSelection.vue?vue&type=script&lang=ts"
export * from "./ProductSelectionProductsSelection.vue?vue&type=script&lang=ts"

import "./ProductSelectionProductsSelection.vue?vue&type=style&index=0&id=2da4323b&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2da4323b"]])

export default __exports__